"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReferralAsRefereeDto = instanceOfReferralAsRefereeDto;
exports.ReferralAsRefereeDtoFromJSON = ReferralAsRefereeDtoFromJSON;
exports.ReferralAsRefereeDtoFromJSONTyped = ReferralAsRefereeDtoFromJSONTyped;
exports.ReferralAsRefereeDtoToJSON = ReferralAsRefereeDtoToJSON;
exports.ReferralAsRefereeDtoToJSONTyped = ReferralAsRefereeDtoToJSONTyped;
/**
 * Check if a given object implements the ReferralAsRefereeDto interface.
 */
function instanceOfReferralAsRefereeDto(value) {
    if (!('redeemed' in value) || value['redeemed'] === undefined)
        return false;
    return true;
}
function ReferralAsRefereeDtoFromJSON(json) {
    return ReferralAsRefereeDtoFromJSONTyped(json, false);
}
function ReferralAsRefereeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'redeemed': json['redeemed'],
        'redeemed_at': json['redeemed_at'] == null ? undefined : json['redeemed_at'],
    };
}
function ReferralAsRefereeDtoToJSON(json) {
    return ReferralAsRefereeDtoToJSONTyped(json, false);
}
function ReferralAsRefereeDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'redeemed': value['redeemed'],
        'redeemed_at': value['redeemed_at'],
    };
}
